module.exports = __webpack_public_path__ + "img/tooth_settings.bba4a718.svg";